import { useCallback } from "react";

import { UnityBridge } from "@Context/common/general/context";

type ReplayWebEventType = typeof UnityBridge.OutgoingWebEvents.ReplayEvent | typeof UnityBridge.OutgoingWebEvents.ReplayUiEvent;

type ReplayWebEventPayload = Record<string, unknown> | undefined;

export const ReplayStreamActions = {
  START_DOWNLOAD: "start_download",
  START_STREAM: "start_stream",
  END_STREAM: "end_stream",
  START: "start",
  SEEK: "seek",
  REPLAY_READY: "replay_ready",
} as const;

export const ReplayUiFeatures = {
  VISION_CONE: "visionCone",
  HEATMAP: "heatmap",
} as const;

type ReplayStreamAction = (typeof ReplayStreamActions)[keyof typeof ReplayStreamActions];

const useSessionReplayStream = (enabled = true) => {
  const dispatchReplayWebEvent = useCallback(
    (type: ReplayWebEventType, payload?: ReplayWebEventPayload) => {
      if (!enabled) return;
      UnityBridge.dispatchWebEvent({
        type,
        payload,
      });
    },
    [enabled]
  );

  return {
    dispatchReplayWebEvent,
  };
};

export default useSessionReplayStream;
